export default class ShopHeader extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    console.log('Header added')
  }
}

customElements.define('shop-header', ShopHeader)
